import axios from "axios";
import router from "@/router/index";
import Vue from "vue";
import { setCurrentSession } from "@/utils/localStorage";

const instance = axios.create({});

// Declarando rota default
instance.defaults.baseURL = process.env.VUE_APP_URL;

// Interceptando requisição
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("sessionToken");
  config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

// Interceptando resposta
instance.interceptors.response.use(
  (config) => {
    setCurrentSession();
    localStorage.setItem("sessionToken", config.headers.authorization);
    return config;
  },

  (error) => {
    if (error.response.data.error === "Unauthenticated.") {
      router.push({ path: "/" });
      localStorage.clear();
      Vue.prototype.$snackbar.setParams(
        "warning",
        "Usuário desconectado",
        "Realize o login novamente para ter acesso ao sistema."
      );
      return;
    }

    if (error.response.status >= 400) {
      if (error.response.data.details === undefined) {
        throw error.response.data.error;
      }

      if (typeof error.response.data.details !== "string") {
        const messages = Object.values(error.response.data.details)
          .map((value) => value.toString())
          .join(" | ");

        throw messages;
      } else {
        throw error.response.data.details;
      }
    }
  }
);

export default instance;
